"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RobotScriptPanel = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var RobotScriptPanel = /** @class */ (function (_super) {
    __extends(RobotScriptPanel, _super);
    function RobotScriptPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RobotScriptPanel.prototype.getIndexKey = function (index) {
        switch (index) {
            case 0:
                return 'A';
            case 1:
                return 'B';
            case 2:
                return 'X';
            case 3:
                return 'Y';
        }
        return '';
    };
    RobotScriptPanel.prototype.componentDidMount = function () {
        var _this = this;
        document.addEventListener("keydown", function (ev) {
            var activeElement = document.activeElement;
            if (activeElement instanceof HTMLInputElement && activeElement.type === 'text')
                return true;
            switch (ev.keyCode) {
                case 65:
                    _this.props.requestRobotScript(0);
                    ev.preventDefault();
                    return false;
                case 66:
                    ev.preventDefault();
                    _this.props.requestRobotScript(1);
                    return false;
                case 88:
                    ev.preventDefault();
                    _this.props.requestRobotScript(2);
                    return false;
                case 89:
                    ev.preventDefault();
                    _this.props.requestRobotScript(3);
                    return false;
            }
            return true;
        });
    };
    RobotScriptPanel.prototype.render = function () {
        var _this = this;
        if (this.props.connectedClient && this.props.connectedClient.robotScripts) {
            if (this.props.connectedClient.robotScripts.length) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "d-flex flex-column w-100" }, this.props.connectedClient.robotScripts.map(function (script) {
                        return (React.createElement("div", { className: "w-100 pb-1", key: script.scriptId },
                            React.createElement(reactstrap_1.Button, { color: _this.props.requestedScriptId === script.scriptId ? 'info' : 'primary', className: "w-100", onClick: function () { return _this.props.requestRobotScript(script.scriptId); } },
                                script.scriptTitle,
                                " ",
                                script.scriptId < 4 && script.scriptId >= 0 ? React.createElement(reactstrap_1.Badge, { color: "light" }, _this.getIndexKey(script.scriptId)) : React.createElement(React.Fragment, null))));
                    }))));
            }
        }
        return (React.createElement(React.Fragment, null));
    };
    ;
    return RobotScriptPanel;
}(React.PureComponent));
exports.RobotScriptPanel = RobotScriptPanel;
//# sourceMappingURL=RobotScriptPanel.js.map